// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ApplicationObservabilitySignetIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon
      data-iconname="ApplicationObservabilitySignetIcon"
      ref={forwardedRef}
      {...props}
    >
      <path d="M11.574 3.715c-.838-3.438-3.65-1.342-3.65-1.342l.003-.012L3.11 5.303a.29.29 0 0 0-.134.244L2.972 9.224c0 .202.193.339.368.261l6.544-3.377a.25.25 0 0 1 .236.017l1.863 1.148c.177.109.399-.027.399-.244l-.708-2.942a8 8 0 0 1-.1-.372" />
      <path d="m13.237 15.9-6.13-4.246a.29.29 0 0 1-.106-.224L6.975 9.142c-.002-.217-.226-.35-.401-.24l-2.615 2.824C2.602 13.498 4.195 14.79 4.78 15.18l5.143 3.069a.25.25 0 0 0 .266-.004l3.024-1.875a.293.293 0 0 0 .022-.47" />
      <path d="m13.836 14.086.727.217c1.956.4 2.376-1.348 2.465-2.207V5.558a.28.28 0 0 0-.133-.245L13.86 3.358c-.165-.102-.373.008-.397.208l-.469 7.83a.28.28 0 0 1-.13.208l-1.865 1.145a.292.292 0 0 0 0 .489l2.39.715a5 5 0 0 1 .447.133" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const ApplicationObservabilitySignetIcon = /* @__PURE__ */ Object.assign(
  ApplicationObservabilitySignetIconComponent,
  { displayName: 'ApplicationObservabilitySignetIcon' },
);
